"use strict";

if (!Array.prototype.last) {
  Array.prototype.last = function () {
    return this[this.length - 1];
  };
}


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/plugins/array.last.js
 **/